export default "__VITE_ASSET__7ba60f0a__"